export default __webpack_public_path__ + "static/media/regulatory--keep-right--g3.0bf791e6.png";